<template>
  <div class="content">
    <div class="body" :loading="loading">
      <div>
        <p class="title">{{ productName }}</p>
      </div>
      <Form ref="form" :model="Array.isArray(formData[tabActive]) ? formData : formData[tabActive]" class="page-form" :label-width="120">
        <Tabs v-model="tabActive">
          <TabPane label="基本信息" name="5"></TabPane>
          <TabPane label="保险责任" name="4"></TabPane>
          <TabPane label="产品简介" name="1"></TabPane>
          <TabPane label="保单权益" name="3"></TabPane>
          <TabPane label="产品活动" name="2"> </TabPane>
          <TabPane label="培训视频" name="7"> </TabPane>
        </Tabs>
        <template v-if="tabActive == 1">
          <FormItem v-show="tabActive == 1" label="标签名称" prop="tags" class="full" :key="999">
            <span v-if="!formData[tabActive].tags || formData[tabActive].tags.length == 0">--</span>
            <Tag v-else color="primary" v-for="tag in formData[tabActive].tags" :key="tag">{{ tag }}</Tag>
          </FormItem>
          <FormItem v-show="tabActive == 1" label="产品简介" prop="description" class="full" :key="1">
            <span v-if="!formData[tabActive].description">--</span>
            <div v-else v-html="formData[tabActive].description"></div>
          </FormItem>
          <FormItem label="产品亮点" prop="feature" style="margin-top: 20px; width: 100%">
            <span v-if="!formData[tabActive].feature">--</span>
            <Row v-else v-for="(item, index) in formData[tabActive].feature" :key="index">
              <Row
                ><Col
                  ><a @click="toUrl(item.path)">{{ item.fileName }}</a></Col
                ></Row
              >
            </Row>
          </FormItem>
        </template>
        <template v-if="tabActive == 2">
          <Table :columns="columns1" :data="formData[tabActive]">
            <template slot-scope="{ row, index }" slot="content">
              <uploadNew2 v-model="formData[tabActive][index].images" :disabled="true" :isDel="false"></uploadNew2>
            </template>
          </Table>
        </template>
        <template v-if="tabActive == 3">
          <div class="rights-wrap">
            <div class="rights-list" v-for="(item, index) in jsonStr" :key="index">
              <div class="rights-label" :class="{ 'active': item.show }">
                {{ item.key }}
                <Icon v-if="item.show" type="ios-checkmark" />
              </div>
              <span v-if="item.show" class="rights-content">{{ item.value }}</span>
            </div>
          </div>
        </template>
        <template v-if="tabActive == 4">
          <Table :columns="columns" :data="formData[tabActive]"> </Table>
        </template>
        <template v-if="tabActive == 5">
          <FormItem label="保险公司" prop="productName">
            <span>{{ $route.query.companyName || '--' }}</span>
          </FormItem>
          <FormItem label="产品类型" prop="productType">
            <lzDicTxt dicType="PRODUCT_TYPE2" :dicCode="formData[tabActive].productType"></lzDicTxt>
          </FormItem>
          <FormItem label="产品发售地" prop="salesLocation">
            <lzDicTxt dicType="PRODUCT_SALE_LOCATION" :dicCode="formData[tabActive].salesLocation"></lzDicTxt>
          </FormItem>
          <FormItem label="是否热销" prop="isHot">
            <span>{{ formData[tabActive].isHot == 1 ? '是' : '否' }}</span>
          </FormItem>
          <FormItem label="产品简称" prop="productName">
            <span>{{ formData[tabActive].productName || '--' }}</span>
          </FormItem>
          <FormItem label="缴费期" prop="paymentPeriod">
            <span>{{ formData[tabActive].paymentPeriod || '--' }}</span>
          </FormItem>
          <FormItem label="保单货币" prop="policyCurrency">
            <span>{{ formData[tabActive].policyCurrency | filterDicTxt('CURRENCY_TYPE') }}</span>
          </FormItem>
          <FormItem v-if="['2'].includes(productType)" label="是否可续保" prop="isRenewed">
            <span>{{ formData[tabActive].isRenewed == '1' ? '是' : '否' }}</span>
          </FormItem>
          <FormItem label="保障期限" prop="guaranteePeriod">
            <span>{{ formData[tabActive].guaranteePeriod || '--' }}</span>
          </FormItem>
          <FormItem v-if="['2'].includes(productType)" label="病房级别配置" prop="wardClass">
            <span>{{ formData[tabActive].wardClass || '--' }}</span>
          </FormItem>
          <FormItem
            v-if="formData[tabActive].guaranteePeriod && formData[tabActive].guaranteePeriod.includes('直至年金期完结')"
            label="年金期"
            prop="annuityTime"
          >
            <span>{{ formData[tabActive].annuityTime | filterDicTxt('ANNUITY_TIME') }}</span>
          </FormItem>
          <FormItem
            v-if="formData[tabActive].guaranteePeriod && formData[tabActive].guaranteePeriod.includes('直至入息期完结')"
            label="入息期"
            prop="annuityPeriod"
          >
            <span>{{ formData[tabActive].annuityPeriod || '--' }}</span>
          </FormItem>
          <FormItem
            v-if="formData[tabActive].guaranteePeriod && formData[tabActive].guaranteePeriod.includes('直至入息期完结')"
            label="入息开始年龄"
            prop="annuityStartAge"
          >
            <span>{{ formData[tabActive].annuityStartAge | filterDicTxt('ANNUITY_START_AGE') }}</span>
          </FormItem>
          <FormItem v-if="(formData[tabActive].guaranteePeriod || '').includes('终身')" label="终身年龄" prop="lifetimeAge">
            <lzDicTxt dicType="LIFETIME_AGE" :dicCode="formData[tabActive].lifetimeAge"></lzDicTxt>
          </FormItem>
          <FormItem v-if="!['2', '4'].includes(productType)" label="是否支持预缴" prop="supportPrepay">
            <span>{{ formData[tabActive].supportPrepay == '1' ? '是' : '否' }}</span>
          </FormItem>
          <FormItem v-if="formData[tabActive].supportPrepay == 1" label="预缴缴费期" prop="prepayPaymentPeriod">
            <span>{{ formData[tabActive].prepayPaymentPeriod || '--' }}</span>
          </FormItem>
          <FormItem v-if="!['8', '6', '3', '7', '4', '2'].includes(productType)" label="保额范围" prop="coverage">
            <span>{{ formData[tabActive].coverage || '--' }}</span>
          </FormItem>
          <FormItem v-if="!['8', '6', '3', '7', '4', '2'].includes(productType)" label="垫底费" prop="excessFee">
            <span>{{ formData[tabActive].excessFee || '--' }}</span>
          </FormItem>
          <FormItem label="所属地" prop="homeAddr">
            <span>{{ formData[tabActive].homeAddr }}</span>
          </FormItem>

          <template v-if="['6'].includes(productType)">
            <FormItem label="是否支持无忧选">
              {{ formData[tabActive].wuyouOption == 'Y/N' ? '是' : '否' }}
            </FormItem>
            <FormItem v-if="formData[tabActive].wuyouOption == 'Y/N'" label="入息支付方式" prop="incomePayType">
              <span>{{ formData[tabActive].incomePayType | filterDicTxt('INCOMEPAY_TYPE') }}</span>
            </FormItem>
            <FormItem v-if="formData[tabActive].wuyouOption == 'Y/N'" label="入息支付选项" prop="incomePayOption">
              <span>{{ formData[tabActive].incomePayOption | filterDicTxt('INCOMEPAY_OPTION') }}</span>
            </FormItem>
          </template>

          <FormItem v-if="!['6', '3', '7', '4', '2'].includes(productType)" label="生日回溯" prop="bitthRetrogression">
            <span>{{ formData[tabActive].bitthRetrogression == '1' ? '是' : '否' }}</span>
          </FormItem>
          <FormItem v-if="!['8', '6'].includes(productType)" label="居住地" prop="placeResidence">
            <span>{{ formData[tabActive].placeResidence || '--' }}</span>
          </FormItem>
          <template v-if="['7'].includes(productType)">
            <FormItem label="年金开始日" prop="annuityStartTime">
              <span>{{ formData[tabActive].annuityStartTime | filterDicTxt('ANNUITY_START_TIME') }}</span>
            </FormItem>
            <FormItem label="年金给付频率" prop="annuityPayPeriod">
              <span>{{ formData[tabActive].annuityPayPeriod | filterDicTxt('ANNUITY_PAYPERIOD') }}</span>
            </FormItem>
            <FormItem label="入息支付方式" prop="annuityPaymentType">
              <span>{{ formData[tabActive].annuityPaymentType | filterDicTxt('ANNUITY_PAYMENT_TYPE') }}</span>
            </FormItem>
            <FormItem label="积累期" prop="accumulationPeriod">
              <span>{{ formData[tabActive].accumulationPeriod | filterDicTxt('ACCUMULATION_PERIOD') }}</span>
            </FormItem>
            <FormItem label="年金年期" prop="annuityTerm">
              <span>{{ formData[tabActive].annuityTerm | filterDicTxt('ANNUITY_TERM') }}</span>
            </FormItem>
          </template>
          <FormItem class="full" label="产品海报" prop="poster">
            <span v-if="!formData[tabActive].poster || formData[tabActive].poster.length == 0">--</span>
            <template v-else>
              <img
                v-for="(item, index) in formData[tabActive].poster"
                class="cover-img"
                @click="handleView('img' + index)"
                :preview="_uid"
                :ref="'img' + index"
                :key="index"
                :src="item.path"
                alt=""
                srcset=""
              />
            </template>
          </FormItem>

          <FormItem label="官方资料" prop="information">
            <span v-if="!formData[tabActive].information || formData[tabActive].information.length == 0">--</span>
            <Row v-else v-for="(item, index) in formData[tabActive].information" :key="index">
              <Row
                ><Col
                  ><a @click="toUrl(item.path)">{{ item.fileName }}</a></Col
                ></Row
              >
            </Row>
          </FormItem>
          <template v-if="['4', '3', '2'].includes(productType) && formData[tabActive].planList && formData[tabActive].planList.length">
            <div class="form-title"><span>计划内容</span></div>
            <FormItem class="full">
              <span v-for="(item, index) in formData[tabActive].planList" :key="'planList' + index"
                >{{ item.name || '--' }}{{ index != formData[tabActive].planList.length - 1 ? '/' : '' }}</span
              >
            </FormItem>
          </template>
          <template v-if="['4'].includes(productType) && formData[tabActive].levelList && formData[tabActive].levelList.length">
            <div class="form-title"><span>承保级别</span></div>
            <FormItem class="full">
              <span v-for="(item, index) in formData[tabActive].levelList" :key="'levelList' + index"
                >{{ item.level || '--' }}{{ index != formData[tabActive].levelList.length - 1 ? '/' : '' }}</span
              >
            </FormItem>
          </template>
          <template v-if="['2'].includes(productType)">
            <template v-if="formData[tabActive].otherPlanList && formData[tabActive].otherPlanList.length">
              <div class="form-title"><span>其他计划</span></div>
              <FormItem class="full">
                <span v-for="(item, index) in formData[tabActive].otherPlanList" :key="'otherPlanList' + index"
                  >{{ item.name || '--' }}{{ index != formData[tabActive].otherPlanList.length - 1 ? '/' : '' }}</span
                >
              </FormItem>
            </template>
            <template v-if="formData[tabActive].excessFeeList && formData[tabActive].excessFeeList.length">
              <div class="form-title"><span>垫底费</span></div>
              <div v-for="(item, index) in formData[tabActive].excessFeeList" :key="'excessFee' + index" class="list-form nwrap">
                <FormItem :label-width="150" label="垫底费（港币）">
                  <span>{{ item.hkd || '--' }}</span>
                </FormItem>
                <FormItem label="垫底费（美元）">
                  <span>{{ item.usd || '--' }}</span>
                </FormItem>
              </div>
            </template>
          </template>
        </template>
        <template v-if="tabActive == 7">
          <video v-if="videoUrl" controls="controls" :src="videoUrl" style="width: 600px; max-height: 600px"></video>
          <noData v-else></noData>
        </template>
      </Form>
    </div>
  </div>
</template>
<script>
const dic = JSON.parse(localStorage.dic);
import filter from '@/api/filter';
import addTag from '@/components/commons/addTag';
import lzDicTxt from '@/components/commons/lzDicTxt';
import uploadNew2 from '@/components/commons/uploadNew2';
import lzDicSelect from '@/components/commons/lzDicSelect';
export default {
  components: {
    addTag,
    lzDicTxt,
    uploadNew2,
    lzDicSelect
  },
  filters: {
    filterDicTxt(dicCode, dicType) {
      if (!dicCode) return '--';
      const dicMap = dic[dicType];
      if (!dicMap) return '--';
      let codeArr = dicCode.split('/');
      let txt = [];
      codeArr.forEach(item => {
        txt.push(dicMap[item] || item);
      });
      return txt.join('/');
    }
  },
  computed: {
    videoUrl() {
      return this.formData[this.tabActive].courseVideo?.videoUrl;
    }
  },
  data() {
    return {
      dic,
      columns1: [
        {
          title: '序号',
          align: 'center',
          width: 80,
          type: 'index'
        },
        {
          title: '活动名称',
          key: 'title',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '活动时间',
          key: 'endTime',
          minWidth: 180,
          align: 'center',
          render(h, { row }) {
            let beginTime = filter.filterTime(row.beginTime, 'YYYY-MM-DD');
            let endTime = filter.filterTime(row.endTime, 'YYYY-MM-DD');
            return (
              <span>
                {beginTime} - {endTime}
              </span>
            );
          }
        },
        {
          title: '活动内容',
          slot: 'content',
          minWidth: 230,
          align: 'center'
        }
      ],
      columns: [
        {
          title: '序号',
          align: 'center',
          width: 80,
          type: 'index'
        },
        {
          title: '责任名称',
          key: 'title',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '责任概述',
          key: 'description',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '责任内容',
          key: 'detailContent',
          minWidth: 230,
          align: 'center'
        }
      ],
      loading: false,
      productType: '',
      productName: '',
      productId: '',
      tabActive: '5',
      jsonStr: [
        { key: '保单延续功能', value: '有', show: false },
        { key: '转换受保人', value: '可透过更改受保人选项及/或第二受保人选项无限次更改受保人。', show: false },
        { key: '转换投保人', value: '可透过更改投保人选项及/或第二投保人选项无限次更改投保人。', show: false },
        { key: '货币转换', value: '保单货币支持转换为美元、港元、欧元等。', show: false },
        { key: '类信托功能', value: '1、可一笔支付;2、可定期定额支取。', show: false },
        { key: '终期红利锁定权', value: '由第15个保单年度终结后起，于每个保单年度终结后起计30日内，您可选择行使红利及分红锁定选项一次。', show: false },
        { key: '年度红利使用', value: '1、支取现金;2、累积红利;', show: false },
        { key: '保单假期', value: '有', show: false },
        { key: '投资标的', value: '债券及其他固定收入工具:25%至100%;增长型资产:0%至75%', show: false },
        { key: '保单暂托', value: '可指定未满18岁的后备持有人(需在成年前设立暂托人)', show: false },
        { key: '红利解锁', value: '有', show: false },
        { key: '年金转换权益', value: '有', show: false },
        { key: '指定收款人', value: '指定一名收款对象接收提取资金', show: false },
        { key: '保费豁免功能', value: '有', show: false },
        { key: '意外身故额外赔付', value: '有', show: false },
        { key: '全球紧急支援服务', value: '有', show: false },
        { key: '子女学业成就奖', value: '有', show: false },
        { key: '初生婴儿奖赏', value: '有', show: false }
      ],
      formData: {
        1: {},
        2: [{}],
        3: {},
        4: [{}],
        5: {},
        7: {}
      }
    };
  },
  async activated() {
    const { name, id, productType } = this.$route.query;
    this.productName = name;
    this.productId = id;
    this.productType = productType || '';
    this.fetchAllDetails();
  },
  methods: {
    numTransCN(num) {
      const digits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
      const units = ['', '十', '百', '千', '万', '十', '百', '千', '亿'];
      let numStr = num.toString();
      let result = '';
      let zeroFlag = false;
      for (let i = 0; i < numStr.length; i++) {
        const digit = parseInt(numStr[i]);
        const position = numStr.length - i - 1;
        if (digit === 0) {
          zeroFlag = true;
        } else {
          if (zeroFlag) {
            result += '零';
            zeroFlag = false;
          }
          result += digits[digit] + units[position];
        }
      }
      if (num >= 10 && num < 20) {
        result = result.replace('一十', '十');
      }
      return result;
    },
    handleView(refname) {
      this.$refs[refname][0].click();
    },
    fetchAllDetails() {
      this.loading = true;
      const productId = this.productId;
      const requestGroups = [
        { tabs: ['1', '5', '7', '3'], url: '/buz/product/detail', params: { productId } },
        { tabs: ['2'], url: '/buz/insuranceProductActivity/detail', params: { productId } },
        { tabs: ['4'], url: '/buz/insuranceProductDuty/detail', params: { productId } }
      ];
      Promise.all(
        requestGroups.map(group =>
          this.$http({ url: group.url, type: 'GET', data: { ...group.params } })
            .then(res => ({ group, data: res.data }))
            .catch(() => ({ group, data: null }))
        )
      ).then(results => {
        results.forEach(({ group, data }) => {
          if (!data) return;
          group.tabs.forEach(active => {
            this.processDetailData(active, data);
          });
        });
        this.loading = false;
      });
    },
    processDetailData(active, data) {
      if (!data) return;
      if (active == 1 && data.tags) {
        data.tags = data.tags.split(',');
      }
      if (active == 1 && data.feature) {
        data.feature = JSON.parse(data.feature || '[]');
      }
      this.formData[active] = data;
      if (active == 2 || active == 4) {
        this.formData[active] = Array.isArray(data) ? (data.length ? data : []) : [data || {}];
      }
      if (active == 2) {
        this.formData[active]?.map(v => {
          v.images = JSON.parse(v.images || '[]');
        });
      }
      if (active == 5) {
        this.formData[active].information = JSON.parse(this.formData[active]?.information || '[]');
        this.formData[active].poster = JSON.parse(this.formData[active]?.poster || '[]');
        this.formData[active].lifetimeAge = (this.formData[active].lifetimeAge || '') + '';
        this.formData[active].isRenewed = (this.formData[active].isRenewed || '') + '';
        if (this.formData[active].planList && Array.isArray(this.formData[active].planList)) {
          const allPlans = [...this.formData[active].planList];
          this.formData[active].planList = allPlans.filter(item => item.type === '1' || !item.type);
          this.formData[active].otherPlanList = allPlans.filter(item => item.type === '2');
        }
        this.formData[active].planList = this.formData[active].planList && this.formData[active].planList.length ? this.formData[active].planList : [];
        this.formData[active].otherPlanList =
          this.formData[active].otherPlanList && this.formData[active].otherPlanList.length ? this.formData[active].otherPlanList : [];
        this.formData[active].levelList = this.formData[active].levelList && this.formData[active].levelList.length ? this.formData[active].levelList : [];
        if (this.formData[active].excessFee && typeof this.formData[active].excessFee === 'string') {
          try {
            this.formData[active].excessFeeList = JSON.parse(this.formData[active].excessFee);
          } catch (e) {
            this.formData[active].excessFeeList = [];
          }
        } else if (Array.isArray(this.formData[active].excessFee)) {
          this.formData[active].excessFeeList = this.formData[active].excessFee;
        } else {
          this.formData[active].excessFeeList = [];
        }
      }
      if (active == 3) {
        data.jsonStr = JSON.parse(data?.jsonStr || '[{}]');
        data.jsonStr.forEach(item => {
          if (this.jsonStr.find(i => i.key === item.key)) {
            let index = this.jsonStr.findIndex(i => i.key === item.key);
            this.jsonStr[index].show = true;
            this.jsonStr[index].value = item.value;
          }
        });
        // 过滤掉show为false的权益项
        this.jsonStr = this.jsonStr.filter(item => item.show);
      }
    },
    toUrl(url) {
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../product';
.title {
  font-weight: 700;
  font-size: 20px;
}
.cover-img {
  max-width: 200px;
  max-height: 200px;
  cursor: zoom-in;
  margin-right: 10px;
}
.save-btn {
  display: block;
  margin: 0 auto;
  width: 130px;
  height: 40px;
}
.list-form {
  display: flex;
  > .ivu-icon {
    font-size: 26px;
    cursor: pointer;
  }
}
.arr-list {
  /deep/.ivu-icon {
    font-size: 26px;
    cursor: pointer;
    position: absolute;
  }
}
.rights-wrap {
  padding: 0 40px;
  .rights-list {
    display: flex;
    margin-bottom: 10px;
    .rights-label {
      flex: 0 0 140px;
      border: 1px solid #dcdee2;
      text-align: center;
      height: 30px;
      line-height: 30px;
      margin-right: 40px;
      border-radius: 4px;
      color: #3c464f;
      position: relative;
      user-select: none;
      .ivu-icon {
        position: absolute;
        right: 6px;
        font-size: 20px;
        top: 4px;
      }
      &.active {
        background-color: #7bbdff;
        color: #fff;
      }
    }
    .rights-content {
      line-height: 30px;
    }
  }
}
.hide-wrap {
  height: 180px;
  overflow: hidden;
}
.btn-wrap {
  text-align: center;
}
.btn-toggle {
  z-index: 2;
  margin: 10px auto;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  background-color: #fff;
  position: relative;
  width: 50px;
  &:hover {
    color: #236dff;
  }
}
.nwrap {
  flex-wrap: nowrap;
}
</style>
